import React from 'react';
import {Form} from 'antd';
import commonRefHOC from '../commonRefHOC';

export default commonRefHOC(Form);